module.exports = __webpack_public_path__ + "img/badge-list-thumb-071.5d129fd2.png";